<template>
  <div>
    <PageTitle :title="pageTitle" title-tag="h2" :back-button="{ url: allArticlesUrl, hiddenAfterSizes: 'sm' }" />
    <div class="px-20 px-sm-30 py-20 py-sm-30 py-lg-40 pages-wrapper">
      <div class="new-container blog-container mx-auto" :dir="$dir()">
        <div class="tp-4 opa-70 pl-20 mb-20 d-none d-sm-block">
          <nuxt-link :to="localePath(allArticlesUrl)">
            <template v-if="$dir() === 'rtl'"> &rarr; </template><template v-else> &larr; </template>
            {{ viewAllArticlesLink }}
          </nuxt-link>
        </div>
        <article
          class="d-grid grid-cols-1 grid-cols-sm-12 gap-sm-30 publishing-detail-container px-20 px-sm-30 px-lg-0"
        >
          <div class="col-span-sm-12 col-span-lg-8 col-start-lg-3 d-grid gap-20 py-20 py-sm-30 py-lg-40">
            <div>
              <header class="marg-bottom-2 tx-center">
                <h1 class="tp-1-2">{{ article.title }}</h1>
                <div class="tp-7 opa-70">
                  <client-only>
                    <p class="mb-0">
                      {{ articlePublishedAt }}
                      <template v-if="article.reading_time">
                        /
                        <span class="text-transform-default">{{
                          $t('scenes.blog.minute-read', {
                            minute: article.reading_time,
                          })
                        }}</span>
                      </template>
                    </p>
                  </client-only>
                </div>
                <Author v-if="author" :author="author" class="justify-content-center" />
              </header>
              <div class="article-content tp-5" v-html="article.content" />
              <template v-if="author">
                <hr />
                <Author :author="author" :withBio="true" />
              </template>
            </div>
          </div>
        </article>
        <div class="d-grid grid-cols-1 grid-cols-sm-12 gap-sm-30">
          <div class="col-span-sm-6 col-start-sm-4 col-span-lg-4 col-start-lg-5 d-grid gap-20 pt-20 pt-sm-30 pt-lg-40">
            <div class="text-center">
              <b-button
                class="d-inline-block text-decoration-none call-to-action dark w-100"
                :to="localePath(allArticlesUrl)"
              >
                {{ viewAllArticlesButton }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Author from '~/components/blog/author'
  import PageTitle from '~/components/shared/page-title.vue'

  export default {
    name: 'PublishingArticle',

    components: {
      Author,
      PageTitle,
    },

    props: {
      pageTitle: { type: String, required: true },
      allArticlesUrl: { type: String, required: true },
      viewAllArticlesLink: { type: String, required: true },
      viewAllArticlesButton: { type: String, required: true },
      article: { type: Object, required: true },
      author: { type: Object, required: false },
    },

    computed: {
      articlePublishedAt() {
        if (process.client) {
          return this.$dateFormat(this.article.published_at, 'PPP')
        }
        return ''
      },
    },
  }
</script>

<style lang="scss" scoped>
  .publishing-detail {
    &-container {
      background-color: #fff;
      background-clip: border-box;
      border: 1px solid rgba(0, 0, 0, 0.125);
      border-radius: 7px;
    }
  }

  .article-content {
    & ::v-deep {
      h2 {
        font-size: 1.25rem;
        font-weight: bold;
        margin-top: 1.5em;
        margin-bottom: 1em;
      }

      h3,
      h4,
      h5,
      h6 {
        font-size: 1.125rem;
        font-weight: bold;
        margin-top: 1.5em;
        margin-bottom: 1em;
      }

      ul {
        display: block;
        list-style: disc;
        padding-left: 1rem;
        margin-top: 1rem;
        margin-bottom: 1rem !important;
      }

      li {
        margin-top: 0.5rem;
      }

      img {
        display: block;
        max-width: 100%;
        height: auto;
      }

      a {
        color: #007bff;
        text-decoration: underline;
      }

      iframe {
        max-width: 100%;
      }
    }
  }
</style>
